<template>
  <div class="new-page-con">
    <Header @onSearch="onSearch">
      <!-- 工具栏 -->
      <Tollbar
        :list="tollbarList"
        :sortList="sortList"
        :conditionsList="conditionsList"
        :selectList="selectList"
        type="3"
        theme="1"
        :isShowSearch.sync="isShowSearch"
        :isShowSelect.sync="isShowSelect"
        @onClearSearch="onClearSearch"
        @onChangeSort="onChangeSort"
      ></Tollbar>
    </Header>
    <div class="new-content-con">
      <!-- 检索条件 -->
      <div
        class="new-search-con"
        :class="{ 'new-content-none-search': !isShowSearch }"
      >
        <span class="clear-search-icon" @click="onClearSearch"
          ><i class="iconfont icon-qingchu"></i> Clear All</span
        >
        <el-form
          ref="searchForm"
          label-position="top"
          :model="searchForm"
          class="new-content-search"
        >
          <!-- HS-Code -->
          <el-form-item label="HS-Code" prop="hsCode">
            <el-select
              clearable
              v-model="searchForm.hsCode"
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              placeholder="Select HS-Code"
              remote
              :remote-method="hsCodeMethod"
              @change="onChangeParams"
              @visible-change="onFocusHsCode"
            >
              <el-option
                v-for="(item, index) in hsCodeList"
                :key="index"
                :label="item.id"
                :value="item.id"
              >
                <div class="flex-between-center">
                  <el-tooltip
                    effect="light"
                    :visible-arrow="false"
                    :disabled="item.id?.length < 25"
                    :content="item.id"
                    placement="right"
                  >
                    <span class="select-name">{{ item.id }}</span>
                  </el-tooltip>

                  <span class="select-num">{{ item.count | FilterNum }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 产品名称 -->
          <el-form-item label="Product Name" prop="productName">
            <el-select
              clearable
              v-model="searchForm.productName"
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              placeholder="Select Product Name"
              remote
              :remote-method="productNameMethod"
              @change="onChangeParams"
              @visible-change="onFocusProductName"
            >
              <el-option
                v-for="(item, index) in productList"
                :key="index"
                :label="item.id"
                :value="item.id"
              >
                <div class="flex-between-center">
                  <el-tooltip
                    effect="light"
                    :visible-arrow="false"
                    :disabled="item.id?.length < 25"
                    :content="item.id"
                    placement="right"
                  >
                    <span class="select-name">{{ item.id }}</span>
                  </el-tooltip>
                  <span class="select-num">{{ item.count | FilterNum }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 制裁类型 -->
          <el-form-item label="Sanction Type" prop="sanctionsType">
            <el-select
              clearable
              v-model="searchForm.sanctionsType"
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              placeholder="Select Sanction Type"
              remote
              :remote-method="sanctionsTypeMethod"
              @change="onChangeParams"
              @visible-change="onFocusSanctionsType"
            >
              <el-option
                v-for="(item, index) in sanctionTypeList"
                :key="index"
                :label="item.id"
                :value="item.id"
              >
                <div class="flex-between-center">
                  <el-tooltip
                    effect="light"
                    :visible-arrow="false"
                    :disabled="item.id?.length < 25"
                    :content="item.id"
                    placement="right"
                  >
                    <span class="select-name">{{ item.id }}</span>
                  </el-tooltip>
                  <span class="select-num">{{ item.count | FilterNum }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 国家或区域 -->
          <el-form-item
            label="Sanctioned Country/Region"
            prop="countryOrRegion"
          >
            <el-select
              clearable
              v-model="searchForm.countryOrRegion"
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              placeholder="Select Sanctioned Country/Region"
              remote
              :remote-method="countryMethod"
              @change="onChangeParams"
              @visible-change="onFocusCountry"
            >
              <el-option
                v-for="(item, index) in countriesOrRegionsList"
                :key="index"
                :label="item.id"
                :value="item.id"
              >
                <div class="flex-between-center">
                  <el-tooltip
                    effect="light"
                    :visible-arrow="false"
                    :disabled="item.id?.length < 25"
                    :content="item.id"
                    placement="right"
                  >
                    <span class="select-name">{{ item.id }}</span>
                  </el-tooltip>
                  <span class="select-num">{{ item.count | FilterNum }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <!-- 列表 -->
      <div class="new-content-right">
        <div class="new-content-total">
          Found over {{ totalCount | FilterNum }} “{{ $route.query.keyword }}”
          results
        </div>
        <div class="new-table-box" v-loading="loading">
          <el-table
            :data="tableData"
            row-key="hsCode"
            class="new-table-con"
            height="100%"
            v-loadmore="handleScroll"
            @selection-change="onChangeSelection"
          >
            <el-table-column
              type="selection"
              reserve-selection
              :width="isShowSelect ? 40 : 10"
              align="right"
            >
            </el-table-column>

            <el-table-column
              prop="goodsCodes1"
              label="HS-Code"
              width="130"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.goodsCodes1 ? scope.row.goodsCodes1 : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="matchPhrase"
              label="Product Name"
              width="220"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row?.matchPhrase ? scope.row.matchPhrase : "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="regionRestrictionType"
              label="Sanction Type"
              min-width="300"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{
                  scope.row?.regionRestrictionType &&
                  scope.row?.regionRestrictionType != "nan"
                    ? scope.row.regionRestrictionType
                    : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="regionRestrictionIso2"
              label="Sanctioned Country/Region"
              width="360"
              class-name="two-column-cell"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <template v-if="scope.row.regionRestrictionIso2?.length > 0">
                  <div class="country_img_box">
                    <img
                      v-for="(country, index) in scope.row
                        .regionRestrictionIso2"
                      :key="index"
                      :src="country.src"
                      :title="country.code"
                      class="country_img"
                    />
                  </div>
                </template>
                <template v-else> - </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/views/newLayout/header.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";
import { productSearch, productSanctionSelectOptions } from "@/api/newApi.js";
import { mixins1 } from "@/mixins/index";
export default {
  mixins: [mixins1],
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= 0.5) {
            binding.value(); // 执行绑定的函数
          }
        });
      },
    },
  },
  components: {
    Header,
    Tollbar,
  },
  watch: {
    isShowSearch: {
      handler(newVal) {
        this.isShowSearch = newVal;
      },
      deep: true,
      immediate: true,
    },
    isShowSelect: {
      handler(newVal) {
        this.isShowSelect = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      tollbarList: [
        {
          icon: "icon-youhua",
          name: "Optimize",
          disabled: true,
        },
        {
          icon: "icon-xuanze",
          name: "Select",
          disabled: true,
        },
        {
          icon: "icon-bianji1",
          name: "Edit",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-filter",
          name: "Sort by",
          disabled: false,
          select: true,
        },
        {
          icon: "icon-shoucang1",
          name: "Collect",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-baocun",
          name: "Saved",
          disabled: true,
          select: true,
        },
        {
          icon: "icon-icon_xinyong_xianxing_jijin-307",
          name: "Compare",
          disabled: true,
        },
        {
          icon: "icon-daochu04",
          name: "Export",
          disabled: true,
        },
        {
          icon: "icon-xiazai",
          name: "Download",
          disabled: true,
        },
        {
          icon: "icon-shuaxin",
          name: "Update",
          disabled: true,
        },
        {
          icon: "icon-judan",
          name: "Report Error",
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: "Share",
          disabled: true,
        },
      ],
      sortList: [
        {
          value: "",
          label: "Default",
        },
        {
          value: "1",
          label: "Ascending",
        },
        {
          value: "2",
          label: "Descending",
        },
      ],
      conditionsList: [
        "HS-Code",
        "Product Name",
        "Sanction Type",
        "Sanctioned Countries or Regions",
      ],
      searchForm: {
        hsCode: "",
        keyword: "", //头部用
        productName: "", //精确用
        sanctionsType: "",
        countryOrRegion: "",
        sortBy: "",
      },
      sanctionTypeList: [],
      hsCodeList: [],
      productList: [],
      countriesOrRegionsList: [],
      tableData: [], // 表格数据
      isShowSearch: true,
      isShowSelect: false, // 是否显示复选框
      selectList: [],
      params: {
        page: 1, // 当前页数
        pageSize: 100, // 每页加载的数据条数
      },
      totalCount: 0,
      loading: false, // 加载状态
      hasMore: true, // 是否还有更多数据
    };
  },
  methods: {
    // 搜索
    onSearch(params) {
      // 调用检索api
      if (params.selectCode == 1) {
        // 公司
        this.$router.push({
          path: "/sanction/companyList",
          query: {
            selectCode: 1,
            keyword: params.searchKeyword,
          },
        });
      } else if (params.selectCode == 2) {
        // 个人
        this.$router.push({
          path: "/sanction/personList",
          query: {
            selectCode: 2,
            keyword: params.searchKeyword,
          },
        });
      } else if (params.selectCode == 3) {
        // 产品本身
        // 参数不同时进行路由替换，否则会报错
        if (params.searchKeyword != this.$route.query.keyword) {
          this.$store.dispatch("app/SetlabelCode", "");
          this.$store.dispatch("app/SetlabelCodeName", "");
          this.$store.dispatch("app/SetarchagAin", true);
          this.$store.commit("setRefreshKey", new Date().getTime());
          this.$router.replace({
            path: "/sanction/productList",
            query: {
              selectCode: 3,
              keyword: params.searchKeyword,
            },
          });
        }
        // 调用检索api
        if (this.$route.query.keyword) {
          this.params.page = 1;
          this.searchForm.keyword = this.$route.query.keyword;
          this.tableData = [];
          this.getSearchList();
        }
      } else {
        // 国家
        this.$router.push({
          path: "/sanction/countryList",
          query: {
            selectCode: 4,
            keyword: params.searchKeyword,
            CountryCode: this.$route.query.CountryCode,
          },
        });
      }
    },
    // 获取一览列表
    async getSearchList() {
      this.loading = true;
      let res = await productSearch({
        page: this.params.page,
        pageSize: this.params.pageSize,
        ...this.searchForm,
      });
      // 将新数据添加到现有数据
      if (res.code == 200) {
        this.totalCount = res?.data?.total || 0;
        const rows = res?.data?.rows || [];
        const newData = rows.map((item) => {
          if (
            item?.regionRestrictionIso2 &&
            item?.regionRestrictionIso2 !== "nan"
          ) {
            const countries = item.regionRestrictionIso2
              .split(";")
              .filter(Boolean);
            item.regionRestrictionIso2 = countries.map((code) => {
              return {
                code: code,
                src: require("../../../static" +
                  this.getCountryImgUrl(code.trim())),
              };
            });
       
          } else {
            item.regionRestrictionIso2 = [];
          }
          return item;
        });

        this.tableData = [...this.tableData, ...newData];
      }

      this.loading = false;
    },
    // hscode搜索
    async hsCodeMethod(query) {
      let res = await productSanctionSelectOptions({
        name: this.$route.query.keyword,
        productOptionType: 3,
        aggregationsKeyWord: query,
        hsCode: "",
        productName: this.searchForm.productName,
        productSanctionType: this.searchForm.sanctionsType,
        productSanctionCountryOrRegion: this.searchForm.countryOrRegion,
      });
      this.hsCodeList = res?.data?.options || [];
    },
    // hscode聚焦时
    onFocusHsCode(val) {
      if (val) {
        this.getSanctionOptions(this.searchForm.hsCode, 3);
      }
    },
    // 产品名称搜索
    async productNameMethod(query) {
      let res = await productSanctionSelectOptions({
        name: this.$route.query.keyword,
        productOptionType: 4,
        aggregationsKeyWord: query,
        hsCode: this.searchForm.hsCode,
        productName: "",
        productSanctionType: this.searchForm.sanctionsType,
        productSanctionCountryOrRegion: this.searchForm.countryOrRegion,
      });
      this.productList = res?.data?.options || [];
    },
    // 产品名称聚焦时
    onFocusProductName(val) {
      if (val) {
        this.getSanctionOptions(this.searchForm.productName, 4);
      }
    },
    // 制裁类型搜索
    async sanctionsTypeMethod(query) {
      let res = await productSanctionSelectOptions({
        name: this.$route.query.keyword,
        productOptionType: 1,
        aggregationsKeyWord: query,
        hsCode: this.searchForm.hsCode,
        productName: this.searchForm.productName,
        productSanctionType: "",
        productSanctionCountryOrRegion: this.searchForm.countryOrRegion,
      });
      this.sanctionTypeList = res?.data?.options || [];
    },
    // 制裁类型聚焦时
    onFocusSanctionsType(val) {
      if (val) {
        this.getSanctionOptions(this.searchForm.sanctionsType, 1);
      }
    },
    // 国家搜索
    async countryMethod(query) {
      let res = await productSanctionSelectOptions({
        name: this.$route.query.keyword,
        productOptionType: 2,
        aggregationsKeyWord: query,
        hsCode: this.searchForm.hsCode,
        productName: this.searchForm.productName,
        productSanctionType: this.searchForm.sanctionsType,
        productSanctionCountryOrRegion: "",
      });
      this.countriesOrRegionsList = res?.data?.options || [];
    },
    // 国家聚焦时
    onFocusCountry(val) {
      if (val) {
        this.getSanctionOptions(this.searchForm.countryOrRegion, 2);
      }
    },
    async getSanctionOptions(val, type) {
      let res = await productSanctionSelectOptions({
        name: this.$route.query.keyword,
        productOptionType: type,
        aggregationsKeyWord: val,
        hsCode: this.searchForm.hsCode,
        productName: this.searchForm.productName,
        productSanctionType: this.searchForm.sanctionsType,
        productSanctionCountryOrRegion: this.searchForm.countryOrRegion,
      });
      if (type == 1) {
        // 制裁类型
        this.sanctionTypeList = res?.data?.options || [];
      }
      if (type == 2) {
        // 国家
        this.countriesOrRegionsList = res?.data?.options || [];
      }
      if (type == 3) {
        // hscode
        this.hsCodeList = res?.data?.options || [];
      }
      if (type == 4) {
        // 产品名称
        this.productList = res?.data?.options || [];
      }
    },
    // 参数改变时
    onChangeParams() {
      this.params.page = 1;
      this.tableData = [];
      this.getSearchList();
    },
    onChangeSelection(val) {
      this.selectList = val;
    },
    // 清空检索条件
    onClearSearch() {
      this.$refs["searchForm"].resetFields();
      this.params.page = 1;
      this.searchForm.keyword = this.$route.query.keyword;
      this.tableData = [];
      this.getSearchList();
    },
    // 清空排序
    onChangeSort(e) {
      this.searchForm.sortBy = e.length > 0 ? e[0] : "";
      if (this.$route.query.keyword) {
        this.params.page = 1;
        this.tableData = [];
        this.getSearchList();
      }
    },
    // 表格滚动
    handleScroll() {
      if (this.hasMore && !this.loading) {
        this.loadData();
      }
    },
    // 加载数据
    loadData() {
      let totalPage = Math.ceil(this.totalCount / this.params.pageSize);
      if (this.params.page == totalPage) {
        this.hasMore = false;
      } else {
        this.params.page += 1;
        this.getSearchList();
      }
    },
  },
  mounted() {
    if (this.$route.query.keyword) {
      this.params.page = 1;
      this.searchForm.keyword = this.$route.query.keyword;
      this.tableData = [];
      const token = localStorage.getItem("token");
      if (token) {
        this.getSearchList();
      }
    }
  },
};
</script>
<style scoped>
.country_img_box {
  display: flex;
  gap: 4px;
}
.country_img {
  width: 32px;
  height: 23px;
}
@media (max-width: 1440px) {
  .country_img {
    width: 24px;
    height: 18px;
  }
}
</style>
